import TripsRegistryScreen from './TripsRegistryScreen';

export default TripsRegistryScreen;
